import axios from "axios";
import { getToken } from "../Utlis/UpdateUsersState";

const getAllPackages = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}payment/packages/`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    return e?.response;
  }
};

const checkoutAPI = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}payment/checkout/`,
      data,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    return e?.response;
  }
};

const manageSubscriptionAPI = async () => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}payment/portal/`,
      {},
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    return e?.response;
  }
};

const getPaymentDetails = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}payment/details/`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response;
  }
};

export {
  getAllPackages,
  checkoutAPI,
  getPaymentDetails,
  manageSubscriptionAPI,
};
